import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/servicios-incluidos/garantia.gif")